var React = require('react');

function Stretcher (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M515.78 394.93a62.25 62.25 0 0 0-56.18-7.3l-43-37.63L524 256h-97.2L368 307.48 309.17 256H212l107.4 94-43 37.63a62.25 62.25 0 0 0-56.18 7.3 64.11 64.11 0 1 0 98.53 40.69l49.25-43.1 49.25 43.1a64 64 0 1 0 98.53-40.69zM256 464a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm224 0a16 16 0 1 1 16-16 16 16 0 0 1-16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M640 160v32a32 32 0 0 1-32 32H177.62a64 64 0 0 1-47.84-21.48l-121.7-128a32 32 0 0 1 2.66-45.17L34.66 8.08a32 32 0 0 1 45.18 2.66L192 128h416a32 32 0 0 1 32 32z","className":"fa-primary","key":2})]);
}

Stretcher.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Stretcher;

Stretcher.default = Stretcher;
